<template>
  <base-card>
    <BaseCardTitle>
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <font-awesome-icon :icon="['far','comment-alt']" /> Communication
        </div>

        <small v-if="cancreate"><font-awesome-icon
          icon="plus"
          class="cursor-pointer"
          @click="create"
        /></small>
      </div>
    </BaseCardTitle>

    <GenericList
      source="messages"
      mode="loadMore"
    >
      <template #element="{ element }">
        <div class="text-muted">
          <small>{{ $moment(element.timestamp).format(dateformat) }}</small>
        </div>
        <div class="mb-1">
          From:
          {{ element.sender.user.first_name }} {{ element.sender.user.last_name }}
        </div>
        <div v-html="element.message" />

        <hr>
      </template>
    </GenericList>
    <!-- <ButtonMore /> -->
    <CommunicationCreate
      ref="create"
      @messageCreated="update()"
    />
  </base-card>
</template>

<script>
import CommunicationCreate from './CommunicationCreate';

export default {
  name: 'Communication',
  components: {
    CommunicationCreate,
  },
  props: {
    cancreate: Boolean,
  },
  methods: {
    update() {
      this.$store.dispatch('messages/getAll');
    },
    create() {
      this.$refs.create.open();
    },
  },
};
</script>

<style lang="scss">
</style>
